__turbopack_context__.v({
  "checkboxlabel": "SnH73a_checkboxlabel",
  "checkboxwrapper": "SnH73a_checkboxwrapper",
  "checkmark": "SnH73a_checkmark",
  "input": "SnH73a_input",
  "wrapper": "SnH73a_wrapper",
});
